import { render } from "./B2bNewUser.vue?vue&type=template&id=04497bbe&scoped=true&lang=pug"
import script from "./B2bNewUser.vue?vue&type=script&lang=js"
export * from "./B2bNewUser.vue?vue&type=script&lang=js"

import "./B2bNewUser.vue?vue&type=style&index=0&id=04497bbe&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04497bbe"]])

export default __exports__